import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import Accordion from 'react-bootstrap/Accordion';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AccordionTables.css';
import RegresaBienFecha from '../tools/regresaBienFecha';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const AccordionTables = ({ data, estados, cursos }) => {
  const [materias, setMaterias] = useState([]);

  useEffect(() => {
    seteaMaterias();
  }, []);

  const seteaMaterias = () => {
    const materiasTotales = data.HorasAsignadas.map((ha) => {
      const materia = data.DatosMaterias.flat().find(x => x.id === ha.idMateria);
      return {
        idAsignacion: ha.id,
        nombreMateria: materia.nombreMateria,
        divMateria: ha.division,
        nombreCurso: materia.curso,
        escuela: materia.escuela,
        horas: materia.bloqueHorario,
        fechaInicio: materia.fechaInicio,
        fechaFinalizacion: materia.fechaFinalizacion,
      };
    });
    setMaterias(materiasTotales);
  };

  const exportAllToExcel = () => {
    const datosParaExcel = materias.map(m => ({
      Curso: m.nombreCurso,
      Materia: m.nombreMateria,
      División: m.divMateria,
      Escuela: m.escuela,
      Horas: m.horas,
      'Fecha de Inicio': RegresaBienFecha(m.fechaInicio),
      'Fecha de Finalización': RegresaBienFecha(m.fechaFinalizacion),
    }));

    const ws = XLSX.utils.json_to_sheet(datosParaExcel);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Todas las Materias');

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, `Materias_Todos_Los_Cursos_${data.docente[0].docenteNombres + "_" + data.docente[0].docenteApellido}.xlsx`);
  };

  // Agrupamos cursos por si están activos o finalizados
  const hoy = new Date();
  const cursosActivos = cursos.filter(curso =>
    materias.some(m => m.nombreCurso === curso.curso && new Date(m.fechaFinalizacion) >= hoy)
  );
  const cursosFinalizados = cursos.filter(curso =>
    materias.some(m => m.nombreCurso === curso.curso && new Date(m.fechaFinalizacion) < hoy)
  );

  const renderAccordionGrupo = (titulo, listaCursos, defaultKeyOffset = 0) => (
    <>
      <h4 className="mt-4">{titulo}</h4>
      <Accordion defaultActiveKey={null}>
        {listaCursos.map((instancia, idx) => (
          <Accordion.Item eventKey={(idx + defaultKeyOffset).toString()} key={instancia.id}>
            <Accordion.Header>Curso {instancia.curso}</Accordion.Header>
            <Accordion.Body>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>Materia</th>
                    <th>División</th>
                    <th>Escuela</th>
                    <th>Horas</th>
                    <th>Fecha de Inicio</th>
                    <th>Fecha de Finalización</th>
                  </tr>
                </thead>
                <tbody>
                  {materias
                    .filter(x => x.nombreCurso === instancia.curso)
                    .map((materia, index) => (
                      <tr key={index}>
                        <td>{materia.nombreMateria}</td>
                        <td>{materia.divMateria}</td>
                        <td>{materia.escuela}</td>
                        <td>{materia.horas}</td>
                        <td>{RegresaBienFecha(materia.fechaInicio)}</td>
                        <td>{RegresaBienFecha(materia.fechaFinalizacion)}</td>

                      </tr>
                    ))}
                </tbody>
              </Table>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </>
  );

  return (
    <>
      <div className="d-flex justify-content-end mb-3">
        <button className="btn btn-primary" onClick={exportAllToExcel}>
          Descargar Excel
        </button>
      </div>

      {renderAccordionGrupo("📘 Cursos Activos", cursosActivos, 0)}
      {renderAccordionGrupo("📕 Cursos Finalizados", cursosFinalizados, 100)}
    </>
  );
};

export default AccordionTables;
